module.exports = __webpack_public_path__ + "static/media/icon.330aa7e1.svg";